/* ==========================================================================
   GOYO Paris — global.js
   Cart drawer (Section Rendering), menu drawer, quantity, variants,
   countdown timers, gallery, sticky ATC, toast. Vanilla, event-delegated.
   ========================================================================== */
(function () {
  'use strict';

  var CART_SECTION = 'cart-drawer';

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function toast(msg) {
    var t = $('#toast');
    if (!t) { t = document.createElement('div'); t.id = 'toast'; t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- drawers (menu + cart) ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    var focusable = d.querySelector('[autofocus], button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }
  function closeDrawer(d) {
    if (typeof d === 'string') d = document.getElementById(d);
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer[aria-hidden="false"]')) document.documentElement.classList.remove('no-scroll');
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function closeAllDrawers() { $all('.drawer[aria-hidden="false"]').forEach(closeDrawer); }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); return; }
    if (e.target.classList && e.target.classList.contains('drawer__overlay')) { closeDrawer(e.target.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllDrawers(); });

  /* ---------- cart: update count + swap drawer HTML ---------- */
  function updateCartCount(count) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }
  function applyDrawerSections(sections) {
    if (!sections) return;
    var html = sections[CART_SECTION];
    if (!html) return;
    // Target the stable #cart-drawer element directly. On real Shopify the section is inside a
    // section group, so its wrapper id is shopify-section-<group-hash>__cart-drawer — NOT
    // shopify-section-cart-drawer. So we replace the drawer element itself, keyed by its own id.
    var tmp = document.createElement('div');
    tmp.innerHTML = html.trim();
    var freshDrawer = tmp.querySelector('#cart-drawer');
    var current = document.getElementById('cart-drawer');
    if (!freshDrawer || !current) return;
    // Preserve open state across re-render (e.g. changing quantity while the drawer is open).
    var wasOpen = current.getAttribute('aria-hidden') === 'false';
    current.replaceWith(freshDrawer);
    if (wasOpen) freshDrawer.setAttribute('aria-hidden', 'false');
    var count = freshDrawer.getAttribute('data-cart-total-count');
    if (count != null) updateCartCount(parseInt(count, 10) || 0);
    // Re-bind the reservation timer to the freshly rendered bar (keeps ticking, same deadline).
    initReserveTimer();
  }

  /* ---------- cart reservation timer ("Vos articles sont réservés") ---------- */
  var RESERVE_KEY = 'goyo_cart_reserve_until';
  var reserveInterval = null;
  function reserveMins() {
    var bar = $('[data-cart-reserve]');
    return bar ? (parseInt(bar.getAttribute('data-reserve-mins'), 10) || 2) : 2;
  }
  function startReservation(mins) {
    try { localStorage.setItem(RESERVE_KEY, String(Date.now() + (mins || 2) * 60000)); } catch (e) {}
  }
  // Restart the countdown from the full duration — called whenever the shopper adds an item.
  function bumpReservation() { startReservation(reserveMins()); initReserveTimer(); }
  function initReserveTimer() {
    if (reserveInterval) { clearInterval(reserveInterval); reserveInterval = null; }
    var el = $('[data-reserve-timer]');
    if (!el) return;
    var mins = reserveMins();
    var until = 0;
    try { until = parseInt(localStorage.getItem(RESERVE_KEY), 10) || 0; } catch (e) {}
    if (!until || until - Date.now() <= 0) { startReservation(mins); until = Date.now() + mins * 60000; }
    function render() {
      var target = $('[data-reserve-timer]');
      if (!target) { if (reserveInterval) { clearInterval(reserveInterval); reserveInterval = null; } return; }
      var remaining = until - Date.now();
      if (remaining <= 0) { until = Date.now() + mins * 60000; startReservation(mins); remaining = until - Date.now(); }
      var m = Math.floor(remaining / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      target.textContent = pad(m) + ':' + pad(s);
    }
    render();
    reserveInterval = setInterval(render, 1000);
  }

  function cartRequest(url, body) {
    body.sections = CART_SECTION;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; });
    });
  }

  function addToCart(id, quantity, opts) {
    opts = opts || {};
    var btn = opts.button;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var body = { id: id, quantity: quantity || 1 };
    if (opts.selling_plan) body.selling_plan = opts.selling_plan;
    if (opts.properties) body.properties = opts.properties;
    return cartRequest('/cart/add.js', body).then(function (res) {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      if (!res.ok) {
        toast((res.data && res.data.description) || 'Ce produit est épuisé.');
        return res;
      }
      applyDrawerSections(res.data.sections);
      bumpReservation();
      if (!opts.silent) openDrawer('cart-drawer');
      return res;
    }).catch(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      toast('Une erreur est survenue. Réessayez.');
    });
  }

  // Offer system: parse "id:qty,id:qty:gift" → add all items (gift lines carry _gift property)
  function offerAddToCart(dataCart, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    var items = String(dataCart || '').split(',').map(function (pair) {
      var parts = pair.split(':');
      var it = { id: parts[0], quantity: parseInt(parts[1], 10) || 1 };
      if (parts[2] === 'gift') it.properties = { _gift: 'true' };
      return it;
    }).filter(function (it) { return it.id; });
    if (!items.length) return;
    return cartRequest('/cart/add.js', { items: items }).then(function (res) {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      if (!res.ok) { toast((res.data && res.data.description) || 'Ce produit est épuisé.'); return res; }
      applyDrawerSections(res.data.sections);
      bumpReservation();
      openDrawer('cart-drawer');
      return res;
    }).catch(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      toast('Une erreur est survenue. Réessayez.');
    });
  }

  function changeLine(payload) {
    return cartRequest('/cart/change.js', payload).then(function (res) {
      if (res.ok) {
        applyDrawerSections(res.data.sections);
        updateCartCount(res.data.item_count || 0);
      }
      return res;
    });
  }

  /* ---------- delegated cart interactions ---------- */
  document.addEventListener('click', function (e) {
    // add to cart (quick add / upsell) via data-add-id
    var add = e.target.closest('[data-add-id]');
    if (add) {
      e.preventDefault();
      addToCart(add.getAttribute('data-add-id'), parseInt(add.getAttribute('data-add-qty'), 10) || 1, { button: add });
      return;
    }
    // offer system ATC — adds the selected offer's item(s), incl. a free gift line
    var offerAtc = e.target.closest('[data-offer-atc]');
    if (offerAtc) {
      e.preventDefault();
      var offersWrap = offerAtc.closest('[data-offers]');
      var chosen = offersWrap && (offersWrap.querySelector('input[name="goyo-offer"]:checked') || offersWrap.querySelector('input[name="goyo-offer"]'));
      if (chosen) offerAddToCart(chosen.getAttribute('data-cart'), offerAtc);
      return;
    }
    // remove line
    var rem = e.target.closest('[data-cart-remove]');
    if (rem) {
      e.preventDefault();
      changeLine({ id: rem.getAttribute('data-cart-remove'), quantity: 0 });
      return;
    }
    // qty +/- in cart drawer
    var q = e.target.closest('[data-cart-qty]');
    if (q) {
      e.preventDefault();
      var key = q.getAttribute('data-cart-key');
      var delta = parseInt(q.getAttribute('data-cart-qty'), 10);
      var current = parseInt(q.getAttribute('data-cart-current'), 10) || 0;
      var next = Math.max(0, current + delta);
      changeLine({ id: key, quantity: next });
      return;
    }
  });

  /* ---------- offer selection: click anywhere on an offer to select it ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-offer-atc]')) return;
    var offerEl = e.target.closest('.offer');
    if (!offerEl) return;
    var input = offerEl.querySelector('.offer-input');
    if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  /* ---------- product form (add to cart + variants) ---------- */
  function initProductForm(form) {
    if (form._init) return; form._init = true;
    var dataEl = form.querySelector('[data-variants-json]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    var idInput = form.querySelector('[name="id"]');

    function currentOptions() {
      return $all('[data-option-index]', form).map(function (el) {
        if (el.type === 'radio') { var checked = form.querySelector('[name="' + el.name + '"]:checked'); return checked ? checked.value : null; }
        return el.value;
      });
    }
    function matchVariant(opts) {
      return variants.find(function (v) { return (v.options || []).every(function (o, i) { return o === opts[i]; }); });
    }
    function fmtMoney(cents) {
      var fmt = (window.GOYO && window.GOYO.moneyFormat) || '{{amount}} €';
      var amount = (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      // Replace any {{amount...}} token (amount, amount_with_comma_separator, etc.)
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    }
    function updateForVariant(v) {
      var priceWrap = $('[data-price-block]');
      if (v && priceWrap) {
        var cur = priceWrap.querySelector('[data-price-current]');
        var cmp = priceWrap.querySelector('[data-price-compare]');
        if (cur) cur.textContent = fmtMoney(v.price);
        if (cmp) {
          if (v.compare_at_price && v.compare_at_price > v.price) { cmp.textContent = fmtMoney(v.compare_at_price); cmp.hidden = false; }
          else { cmp.hidden = true; }
        }
      }
      var submit = form.querySelector('[type="submit"]');
      if (submit) {
        if (!v || v.available === false) { submit.setAttribute('disabled', ''); submit.querySelector('[data-atc-text]') && (submit.querySelector('[data-atc-text]').textContent = 'Épuisé'); }
        else { submit.removeAttribute('disabled'); submit.querySelector('[data-atc-text]') && (submit.querySelector('[data-atc-text]').textContent = submit.getAttribute('data-atc-label') || 'Ajouter au panier'); }
      }
      if (v && idInput) idInput.value = v.id;
      // sticky bar mirror
      var stickyPrice = $('[data-sticky-price]');
      if (v && stickyPrice) stickyPrice.textContent = fmtMoney(v.price);
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) {
        var v = matchVariant(currentOptions());
        updateForVariant(v);
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      var submit = form.querySelector('[type="submit"]');
      addToCart(idInput.value, qty, { button: submit });
    });

    // init state
    if (idInput && variants.length) {
      var initial = variants.find(function (v) { return String(v.id) === String(idInput.value); }) || variants[0];
      updateForVariant(initial);
    }
  }

  /* ---------- quantity steppers (generic) ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val = Math.max(1, val + parseInt(step.getAttribute('data-qty-step'), 10));
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product media gallery ---------- */
  function initGallery(g) {
    if (g._init) return; g._init = true;
    g.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var idx = thumb.getAttribute('data-gallery-thumb');
      $all('[data-gallery-slide]', g).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-gallery-slide') === idx); });
      $all('[data-gallery-thumb]', g).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    });
  }

  /* ---------- countdown timers (to the client's local midnight) ---------- */
  window.GOYO = window.GOYO || {};
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function nextMidnight() {
    var d = new Date();
    d.setHours(24, 0, 0, 0); // next local midnight in the client's own timezone
    return d.getTime();
  }
  function initCountdowns() {
    var timers = $all('[data-countdown-midnight]');
    if (!timers.length) return;
    function tick() {
      var end = nextMidnight();
      var diff = Math.max(0, end - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      timers.forEach(function (el) {
        var hEl = el.querySelector('[data-cd-h]'), mEl = el.querySelector('[data-cd-m]'), sEl = el.querySelector('[data-cd-s]');
        if (hEl) hEl.textContent = pad(h); if (mEl) mEl.textContent = pad(m); if (sEl) sEl.textContent = pad(s);
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- offer system: apply the default-selected offer ---------- */
  function initOfferDefaults() {
    $all('[data-offers]').forEach(function (mod) {
      var idx = parseInt(mod.getAttribute('data-default-offer'), 10);
      var inputs = mod.querySelectorAll('.offer-input');
      if (!inputs.length) return;
      if (mod.querySelector('.offer-input:checked')) return; // respect a pre-checked one
      var target = (idx && inputs[idx - 1]) ? inputs[idx - 1] : inputs[0];
      target.checked = true;
    });
  }

  /* ---------- sticky mobile ATC ---------- */
  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    obs.observe(anchor);
    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-add]')) {
        var offerAtc = $('[data-offer-atc]');
        if (offerAtc) { offerAtc.click(); return; }
        var form = $('[data-product-form]');
        if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
    });
  }

  /* ---------- product carousel (arrows) ---------- */
  function initCarousels() {
    $all('[data-carousel]').forEach(function (c) {
      var track = c.querySelector('[data-carousel-track]');
      if (!track) return;
      var prev = c.querySelector('[data-carousel-prev]');
      var next = c.querySelector('[data-carousel-next]');
      function step() {
        var slide = track.querySelector('.carousel__slide');
        return slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      }
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      function updateArrows() {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      track.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  /* ---------- init ---------- */
  function initAll() {
    $all('[data-product-form]').forEach(initProductForm);
    $all('[data-gallery]').forEach(initGallery);
    initCountdowns();
    initOfferDefaults();
    initStickyAtc();
    initCarousels();
    initReserveTimer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // expose
  window.GOYO.addToCart = addToCart;
  window.GOYO.openDrawer = openDrawer;
})();
